import { Inject, Injectable } from '@angular/core'
import { Effect, Actions, ofType } from '@ngrx/effects'
import { of } from 'rxjs/observable/of'
import { catchError, debounceTime, map, mergeMap, switchMap } from 'rxjs/operators'
import { IScheduler } from 'rxjs/Scheduler'
import { async } from 'rxjs/scheduler/async'
import { environment } from '../../../../../environments/environment'
import { VendorUserImageV1 } from '../../../../api/api/models/vendor-user-image-v1'
import { JeanService } from '../../../../api/api/services/jean.service'

import * as App from '../../../../store/actions/app.actions'
import * as User from '../actions/user.actions'

@Injectable()
export class UserEffects {

  constructor(private actions$: Actions,
              private jeanService: JeanService,
              @Inject('DEBOUNCE_TIME') private delayTime: number = environment.debounceTime,
              @Inject('SCHEDULER') private scheduler: IScheduler = async) {
  }

  @Effect()
  saveProfile$ = this.actions$.pipe(
    ofType(User.SAVE_PROFILE),
    debounceTime(this.delayTime, this.scheduler),
    map((action: User.SaveProfile) => action.payload),
    switchMap(({user}) =>
      this.jeanService
        .UpdateVendorUser({
          model: {
            name: user.name,
            email: user.email,
            position: user.position,
          },
          vendorUserId: user.id,
          version: '1'
        }).pipe(
          mergeMap(res => [
            new App.ApiCallSuccess({
              title: 'Saved',
              msg: 'Profile was saved.'
            }),
            new User.SaveProfileSuccess({user})
          ]),
          catchError(error => {
            return of(new App.ApiCallFailure({
              title: 'Error',
              msg: 'Profile was not saved.'
            }))
        }))
    ))

  @Effect()
  uploadImage$ = this.actions$.pipe(
    ofType(User.UPLOAD_IMAGE),
    debounceTime(this.delayTime, this.scheduler),
    map((action: User.UploadImage) => action.payload),
    switchMap(data =>
      this.jeanService
        .UploadVendorUserImage({
          model: {base64Image: data.base64Img},
          vendorUserId: data.user.id,
          version: '1'
        }).pipe(
          mergeMap((res: VendorUserImageV1) => [
            new App.ApiCallSuccess({
              title: 'Uploaded',
              msg: 'Image was uploaded.'
            }),
            new User.UploadImageSuccess({imgUrl: res.imgUrl})
          ]),
          catchError(error => of(new App.ApiCallFailure({
            title: 'Error',
            msg: 'Image was not uploaded.'
        }))))
    ))
}



// WEBPACK FOOTER //
// ./src/app/shared/auth/store/effects/user.effects.ts